module.exports = __webpack_public_path__ + "img/storeStory_entrance_icon.41c3d3ca.png";